var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_327_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1981_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_548_",
    d: "M24.4,19.5H1.6c-0.9,0-1.6-0.7-1.6-1.6V8.1c0-0.9,0.7-1.6,1.6-1.6h22.8c0.9,0,1.6,0.7,1.6,1.6v9.8 C26,18.8,25.3,19.5,24.4,19.5z M1.6,8.1v9.8h22.8V8.1H1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1980_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_545_",
    d: "M24.4,19.5H1.6c-0.9,0-1.6-0.7-1.6-1.6V8.1c0-0.9,0.7-1.6,1.6-1.6h22.8c0.9,0,1.6,0.7,1.6,1.6v9.8 C26,18.8,25.3,19.5,24.4,19.5z M1.6,8.1v9.8h22.8V8.1H1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1978_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1236_",
    d: "M21,12.5c0,0.8-0.7,1.5-1.5,1.5h-13C5.7,14,5,13.3,5,12.5l0,0C5,11.7,5.7,11,6.5,11h13 C20.3,11,21,11.7,21,12.5L21,12.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/Button.a0fe1fe5eff37e7eac40f084e3aafda5.svg";
export { ForwardRef as ReactComponent };